import Toast, { IToast } from "src/components/Toasts/Toast";
import toast, { ToastOptions } from "react-hot-toast";

export function customToast(props: IToast, options?: ToastOptions) {
  toast.custom(<Toast {...props} />, options);
}
